import { ExportFormat } from '@ecosystem/newron-client-lib';
import { EmptyTabsPage, EnabledExportPages, EnabledExportsMap, ProductsTabView, ViewType } from '../Model';
import { ExploreTabView, TradingAssistantTabView } from '@components/tab-nav/TabConfig';

export enum LimitedExportCountryProduct {
  CH_MOBILE_ENHANCE = 'CH_MOBILE ENHANCE.',
}

export const modalContent = {
  modalHeaderText: 'Download data',
  modalMessage: "You're about to download the currently visible data set.",
};

export const modalContentWithExportLimitMessage = {
  modalHeaderText: 'Download data',
  modalMessage:
    "You're about to download the currently visible data set.<br/>Up to 5000 products can be exported to Excel for this category.",
};

// Store the export settings for different modules, tabs and views
export const ENABLED_EXPORTS_MAP: EnabledExportsMap = {
  [EnabledExportPages.RetailerOverview]: {
    [EmptyTabsPage.None]: {
      [ViewType.CombinedChart]: {
        exportFormats: [ExportFormat.Pptx, ExportFormat.Png],
        ...modalContent,
      },
      [ViewType.LineChart]: {
        exportFormats: [ExportFormat.Pptx, ExportFormat.Png],
        ...modalContent,
      },
    },
  },
  [EnabledExportPages.PerformanceAnalysis]: {
    [EmptyTabsPage.None]: {
      [ViewType.LineChart]: {
        exportFormats: [ExportFormat.Xlsx, ExportFormat.Pptx, ExportFormat.Png],
        ...modalContent,
      },
      [ViewType.StackedChart]: {
        exportFormats: [ExportFormat.Xlsx, ExportFormat.Pptx, ExportFormat.Png],
        ...modalContent,
      },
      [ViewType.Table]: {
        exportFormats: [ExportFormat.Xlsx],
        ...modalContent,
      },
      [ViewType.BarChart]: {
        exportFormats: [ExportFormat.Xlsx],
        ...modalContent,
      },
    },
  },
  [EnabledExportPages.CategoryLeaderboard]: {
    [EmptyTabsPage.None]: {
      [ViewType.Table]: {
        exportFormats: [ExportFormat.Xlsx],
        ...modalContent,
      },
      [ViewType.BarChart]: {
        exportFormats: [ExportFormat.Xlsx, ExportFormat.Pptx, ExportFormat.Png],
        ...modalContent,
      },
    },
  },
  [EnabledExportPages.OpportunityReview]: {
    [EmptyTabsPage.None]: {
      [ViewType.Table]: {
        exportFormats: [ExportFormat.Xlsx],
        ...modalContent,
      },
      [ViewType.BubbleChart]: {
        exportFormats: [ExportFormat.Xlsx, ExportFormat.Pptx, ExportFormat.Png],
        ...modalContent,
      },
    },
  },
  [EnabledExportPages.Products]: {
    [ProductsTabView.Leaderboard]: {
      [ViewType.Table]: {
        exportFormats: [ExportFormat.Xlsx],
        ...modalContent,
        exportModalSettingsOverrides: {
          [LimitedExportCountryProduct.CH_MOBILE_ENHANCE]: {
            exportFormats: [ExportFormat.Xlsx],
            ...modalContentWithExportLimitMessage,
          },
        },
      },
      [ViewType.LineChart]: {
        exportFormats: [ExportFormat.Xlsx, ExportFormat.Pptx, ExportFormat.Png],
        ...modalContent,
      },
      [ViewType.BarChart]: {
        exportFormats: [ExportFormat.Xlsx, ExportFormat.Pptx, ExportFormat.Png],
        ...modalContent,
      },
    },
    [ProductsTabView.Trends]: {
      [ViewType.LineChart]: {
        exportFormats: [ExportFormat.Xlsx, ExportFormat.Pptx, ExportFormat.Png],
        ...modalContent,
      },
    },
  },
  [EnabledExportPages.Explore]: {
    [ExploreTabView.Leaderboard]: {
      [ViewType.Table]: {
        exportFormats: [ExportFormat.Xlsx],
        ...modalContent,
      },
      [ViewType.BarChart]: {
        exportFormats: [ExportFormat.Xlsx, ExportFormat.Pptx, ExportFormat.Png],
        ...modalContent,
      },
    },
    [ExploreTabView.Trends]: {
      [ViewType.LineChart]: {
        exportFormats: [ExportFormat.Xlsx, ExportFormat.Pptx, ExportFormat.Png],
        ...modalContent,
      },
      [ViewType.StackedChart]: {
        exportFormats: [ExportFormat.Xlsx, ExportFormat.Pptx, ExportFormat.Png],
        ...modalContent,
      },
    },
    [ExploreTabView.Segments]: {
      [ViewType.StackedChart]: {
        exportFormats: [ExportFormat.Xlsx, ExportFormat.Pptx, ExportFormat.Png],
        ...modalContent,
      },
    },
  },
  [EnabledExportPages.TradingAssistant]: {
    [TradingAssistantTabView.SupplierReview]: {
      [ViewType.ButterflyChart]: {
        exportFormats: [ExportFormat.Xlsx, ExportFormat.Pptx, ExportFormat.Png],
        ...modalContent,
      },
    },
  },
};
